<template>
    <div class="container remove-padding-margin bg-gray" id="homeoutletworkshop">
        <div class="header-top bg-white">
            <div class="row justify-content-center align-items-center set-row w-limit">
                <div class="col-md-2 col-sm-2 col-2 remove-padding">
                    <img src="../../assets/gambar/back-blue.svg" alt="" @click="back">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Pilih Workshop</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2"></div>
            </div>
        </div>
        <main class="add-padding-default pageDefault">
            <div class="tab-pane fade show active" id="nav-Outlet" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="flex-100" id="workshop">
                    <div class="flex-1 pad-top-50">
                        <div class="carddd p-t-24">
                            <div class="set-card-wo-xp-20 pb-0" v-for="w in workshop" :key="w.idworkshop"
                                 @click="chooseWorkshop(w)">
                                <div class="row add-padding-default remove-margin">
                                    <div class="col-md-10 col-sm-10 col-10  remove-padding nomore">
                                        <div class="font-16 remove-margin font-weight-bold nomore capitalize">
                                            {{ w.nama }}
                                        </div>
                                        <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle">
                                            {{ w.alamat }}
                                        </div>
                                        <div class="font-13 f-c-midgrey mar-bot-10 nomore capitalize addressstyle"
                                             style="margin-bottom: 10px;">
                                            {{ w.kota }}
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2  remove-padding text-right">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "PilihWorkshopSingle",
        data() {
            return {
                workshop: [],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
            }
        },
        mounted() {
            this.getSingleWorkshop()
        },
        methods: {
            back() {
                this.$emit("back")
            },
            async getSingleWorkshop() {
                this.workshop = []
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_single', this.requestHeaders)
                    if (response.data.status) {
                        this.workshop = response.data.data;
                    } else {
                        this.$toast.error(response.data.message)
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                }
            },
            chooseWorkshop(workshop) {
                this.$emit("workshopSelected", workshop)
            }
        }
    }
</script>